import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import RelationshipEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class RelationshipNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    render() {
        return (
            <div>
                <RelationshipEditForm />
            </div>
        );
    }
}

export default RelationshipNew


// WEBPACK FOOTER //
// ./src/relationship/new.component.jsx